import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
export default {
  name: 'ConfiguratorTcVars',

  data() {
    return {
      tcVars: Object.seal({
        env_country: '',
        env_language: '',
        env_template: 'Configurateur',
        page_url: this.$route.path,
        ga_activated: 1,
        user_email: '',
        user_id: '',
        user_category: '',
        user_firstvisit_date: '',
        user_logged: false,
        earlybirds_widgets: null
      })
    };
  },

  computed: _objectSpread({}, mapGetters({
    user: 'customer/user',
    userLogged: 'customer/isConnected',
    locale: 'i18n/locale'
  })),

  created() {
    this.setTcVars('init configurator');
    this.$root.$on('reset-tcvars', () => {
      this.setTcVars('configurator reset tcVars');
    });
  },

  beforeDestroy() {
    this.$root.$off('reset-tcvars');
  },

  methods: {
    setTcVars(message) {
      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.user_logged = this.userLogged;

      if (this.userLogged && process.client) {
        this.tcVars.user_email = this.user.user_email;
        this.tcVars.user_id = this.user.user_id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || this.user.user_type || '';
        this.tcVars.user_firstvisit_date = this.$cookies.get('MDM[date_first_visit]') || this.user.date_first_visit;
      }

      if (process.client) {
        this.tcVars.earlybirds_widgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS'));
      }

      if (process.client && window.ga === undefined) {
        this.tcVars.ga_activated = 0;
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    }

  },
  render: h => h(null)
};